import type { Language } from "../i18n";
import { t } from "../i18n";

export interface TorchToggleProps {
  hasTorch: boolean;
  isTorchOn: boolean;
  onToggle: () => void | Promise<void>;
  language?: Language;
}

/**
 * Torch toggle button controlling the camera flashlight in the viewfinder.
 * Safely hides when torch capability is unsupported by the device/track.
 */
export function TorchToggle({
  hasTorch,
  isTorchOn,
  onToggle,
  language = "ru",
}: TorchToggleProps) {
  if (!hasTorch) return null;

  return (
    <button
      type="button"
      className={`torch-button ${isTorchOn ? "torch-button--active" : ""}`}
      onClick={onToggle}
      aria-label={isTorchOn ? t(language, "torch_aria_on") : t(language, "torch_aria_off")}
      aria-pressed={isTorchOn}
      data-testid="torch-toggle-button"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
      <span>{isTorchOn ? t(language, "torch_on") : t(language, "torch")}</span>
    </button>
  );
}
